<form [formGroup]="dynamicForm">
    <div *ngFor="let field of formConfig">
        <div
            *ngIf="field.display != false && (!field.showIf || (dynamicForm?.get(field.showIf.fieldName)?.value && field?.showIf?.value && (field?.showIf?.value.indexOf(dynamicForm?.get(field.showIf.fieldName)?.value) >= 0 ) ) ) 
                        && (!field.showElse || (dynamicForm?.get(field.showElse.fieldName)?.value && field?.showElse?.value && (field?.showElse?.value.indexOf(dynamicForm?.get(field.showElse.fieldName)?.value) < 0 ) ) )  ">
            <div class="form-field">
                <label class="font_18_a32_700">{{ field.question }} <span style="color: red;" *ngIf="field.isRequired">*
                    </span>
                </label>
                <ng-container [ngSwitch]="field.type">
                    <ng-container>
                        <!-- Currency Field -->
                        <mat-form-field *ngSwitchCase="'currency'" appearance="fill" class="genericTextFiled_h60 w_100"
                            [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                            <mat-label>{{ field.label }}<span style="color: red;"
                                    *ngIf="field.isSubRequired">*</span></mat-label>
                            <input matInput class="mt-2" [formControlName]="field.name" (blur)="onBlur(field)"
                                (change)="currencyValueChange(field.name)" [id]="field.name" type="text"
                                appCurrencyFormatter>
                        </mat-form-field>

                        <!-- Number Field -->
                        <mat-form-field *ngSwitchCase="'number'" appearance="fill" class="genericTextFiled_h60 w_100"
                            [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                            <mat-label>{{ field.label }}<span style="color: red;"
                                    *ngIf="field.isSubRequired">*</span></mat-label>
                            <input matInput class="mt-2" [formControlName]="field.name" [id]="field.name" type="number"
                                (blur)="onBlur(field)">
                        </mat-form-field>

                        <!-- Text Field -->
                        <mat-form-field *ngSwitchCase="'text'" appearance="fill" class="genericTextFiled_h60 w_100"
                            [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                            <mat-label>{{ field.label }}<span style="color: red;"
                                    *ngIf="field.isSubRequired">*</span></mat-label>
                            <input matInput class="mt-2" [formControlName]="field.name" [id]="field.name" type="text"
                                (blur)="onBlur(field)">
                        </mat-form-field>

                        <!-- Textarea -->
                        <mat-form-field *ngSwitchCase="'textarea'" appearance="fill" class="genericTextFiled_h60 w_100"
                            [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                            <mat-label>{{ field.label }}</mat-label>
                            <textarea class="mb-2 textfield" matInput [formControlName]="field.name" [id]="field.name"
                                (blur)="onBlur(field)" type="text"></textarea>
                        </mat-form-field>

                        <!-- Note -->
                        <div class="field-info field-note" *ngIf="field.note">
                            <p *ngIf="field.hasShowMore">{{ field.note | slice:0:(field.hasShowMore ? (showMore ?
                                undefined : 300) : undefined)
                                }}</p>
                            <p *ngIf="!field.hasShowMore" [innerHTML]="field.note "></p>
                            <button *ngIf="field.hasShowMore" class="toggle-button show-more"
                                (click)="showMore = !showMore">
                                {{ showMore ? 'Show less' : 'Show more' }}
                            </button>
                        </div>

                        <!-- Email Field -->
                        <mat-form-field *ngSwitchCase="'email'" appearance="fill" class="genericTextFiled_h60 w_100"
                            [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                            <mat-label>{{ field.label }}</mat-label>
                            <input matInput [formControlName]="field.name" [id]="field.name" type="email"
                                (blur)="onBlur(field)">
                        </mat-form-field>

                        <!-- Select Dropdown -->
                        <div class="state_zip">
                            <mat-form-field *ngSwitchCase="'select'" appearance="fill"
                                class="genericTextFiled_h60 w_100"
                                [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                                <mat-label>{{ field.label }}</mat-label>
                                <mat-select [formControlName]="field.name" [id]="field.name" (blur)="onBlur(field)">
                                    <mat-option *ngFor="let option of field.options" [value]="option.value">
                                        {{ option.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <!-- Radio Button -->
                        <div *ngSwitchCase="'radio'" class="home_type">
                            <mat-radio-group [formControlName]="field.name" (blur)="onBlur(field)">
                                <mat-radio-button color="primary" *ngFor="let option of field.options"
                                    [ngClass]="{radiofield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}"
                                    [value]="option.value">
                                    {{ option.viewValue }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <!-- Checkbox -->
                        <mat-checkbox *ngSwitchCase="'checkbox'" [formControlName]="field.name" (blur)="onBlur(field)">
                            {{ field.label }}
                        </mat-checkbox>

                        <!-- Card Selection -->
                        <div *ngSwitchCase="'card'" class="home_type">
                            <div class="home_type_card_wrap">
                                <ng-container *ngFor="let card of field.options">
                                    <div *ngIf="((!card.showIf || (dynamicForm?.get(card.showIf.fieldName)?.value && card?.showIf?.value && (card?.showIf?.value.indexOf(dynamicForm?.get(card.showIf.fieldName)?.value) >= 0 ) ) ) 
                        && !card.showElse || (dynamicForm?.get(card.showElse.fieldName)?.value && card?.showElse?.value && (card?.showElse?.value.indexOf(dynamicForm?.get(card.showElse.fieldName)?.value) < 0 ) ) )"
                                        class="cards" (click)="selectCard(field.name, card.title)"
                                        (blur)="onBlur(field)"
                                        [ngClass]="{'selected': dynamicForm?.get(field.name).value === card.title}">
                                        <img [src]="card.src" alt="">
                                        <p class="card_title">{{ card.title }}</p>
                                    </div>
                                </ng-container>
                            </div>
                        </div>


                        <!-- Custom Field (Rooms) -->
                        <div *ngIf="field.type === 'rooms'" class="bedroom_wrapper" style="margin-top: 30px;">
                            <div class="bedroom">
                                <div class="bedroom_cards" *ngFor="let RoomType of field.options"
                                    [ngClass]="{'selected': RoomType.id === dynamicForm?.get(field.name).value}"
                                    (click)="selectBedroom(field.name, RoomType.id)" (blur)="onBlur(field)">
                                    <p>{{ RoomType.title }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- Chip-list Field -->
                        <div *ngSwitchCase="'chip-list'" class="desc-form mt-10 m-mb-15">
                            <div class="fields">
                                <mat-form-field class="w_100 genericTextFiled_h60"
                                    [ngClass]="{errorfield: dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched}">
                                    <mat-select placeholder="Select option" [formControl]="dynamicForm.get(field.name)"
                                        multiple>
                                        <mat-select-trigger>
                                            <mat-chip-grid #chipGrid>
                                                <!-- Display selected items as chips -->
                                                <mat-chip-row *ngFor="let item of dynamicForm?.get(field.name).value"
                                                    (removed)="removeItem(field.name, item)">
                                                    {{item}}
                                                    <button matChipRemove [attr.aria-label]="'remove ' + item">
                                                        <mat-icon>cancel</mat-icon>
                                                    </button>
                                                </mat-chip-row>
                                            </mat-chip-grid>
                                            <span *ngIf="!dynamicForm?.get(field.name).value?.length"
                                                class="placeholder-message">
                                                Please select an option
                                            </span>
                                        </mat-select-trigger>
                                        <mat-option *ngIf="!field.options || field.options.length === 0" disabled>
                                            No options available
                                        </mat-option>
                                        <mat-option *ngFor="let option of field.options" [value]="option"
                                            (blur)="onBlur(field)">
                                            {{ option }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <!-- Validation Error Messages -->
                        <mat-error class="error-message"
                            *ngIf="dynamicForm?.get(field.name).invalid && dynamicForm?.get(field.name).touched">
                            <img src="../../../assets/images/info.png"> {{ getErrorMessage(field) }}
                        </mat-error>

                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</form>